<div
  *ngrxLet="{
    processError: (customFacade.GetCustomMaterialProcessError$ | async),
    error: (customFacade.customMaterialIngredirentError$ | async)
  } as material"
  class="modal-content"
  piqetAngularDraggable
>
  <ng-container
    *ngrxLet="{
      materialIngredients: (customFacade.materialIngredientList$ | async),
      materialProcessList: (customFacade.materialProcessList$ | async)
    } as customMaterialData"
  >
    <div class="modal-header">
      <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
        <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
          {{ modalLabel }}
        </div>
      </h2>

      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body body-modal">
      <form
        id="frmProjectCreate"
        class="cutomBtn-margin"
        [formGroup]="addNewCustomMaterialForm"
        (keydown.enter)="$event.preventDefault()"
      >
        <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
        <div class="row" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
          <div class="col-sm-12">
            <div class="form-group required">
              <piqet-angular-common-input
                formControlName="materialName"
                [control]="addNewCustomMaterialForm.get('materialName')"
                label="Material name"
                placeholder="Material name"
                [maxLength]="50"
                [submitted]="finalSubmitted"
                [errorMessages]="{
                  required: 'Material name is required',
                  whitespace: 'Material name is required'
                }"
              >
              </piqet-angular-common-input>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group textarea">
              <div class="services-form desc">
                <textarea
                  formControlName="description"
                  cols="20"
                  id="Description"
                  name="Description"
                  rows="2"
                  placeholder="Description"
                ></textarea>
                <label>Description</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
          <input
            data-val="true"
            data-val-number="The field Organization name must be a number."
            data-val-required="Organization is required"
            id="OrganizationId"
            name="OrganizationId"
            type="hidden"
            value="2"
          />
          <div class="col-sm-12" *ngIf="isHideDropDown" style="margin-top: 6px">
            <div class="form-group required">
              <label
                *ngIf="addNewCustomMaterialForm.get('organizationName')?.value"
                class="sub-header-drpdown pb-2"
                >Organization</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #material
                [items]="organizationlist"
                [searchable]="false"
                bindLabel="name"
                formControlName="organizationName"
                [searchFn]="commonInputSearchForOrganization"
                [readonly]="isDisabledDropDown"
                placeholder="Organization"
                [(ngModel)]="setOrganizationValue"
                (change)="selectValue($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      (input)="material.filter($any($event.target).value)"
                      class="accordion-search form-control search-input"
                      id="inputValidation"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (addNewCustomMaterialForm.controls['organizationName']?.touched &&
                    addNewCustomMaterialForm.controls['organizationName']?.invalid) ||
                  addNewCustomMaterialForm.controls['organizationName'].value?.name ===
                    'Organization' ||
                  (finalSubmitted &&
                    !addNewCustomMaterialForm.controls['organizationName'].value?.name)
                "
                class="input-error"
              >
                Organization is required.
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group required">
              <label
                *ngIf="addNewCustomMaterialForm.get('mainMaterial')?.value"
                class="sub-header-drpdown pb-2"
                >At End-of-life treat the composite material as
              </label>
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                class="accordion-text addScroll"
                #select
                [items]="materialList"
                [searchable]="false"
                formControlName="mainMaterial"
                bindLabel="description"
                [searchFn]="commonInputSearch"
                placeholder="At End-of-life treat the composite material as *"
                bindValue="id"
                [virtualScroll]="true"
                [ngClass]="{ 'is-invalid': finalSubmitted }"
                groupBy="childItems"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="accordion-search form-control search-input"
                      id="inputValidation"
                      (input)="select.filter($any($event.target).value)"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                    {{ item?.description }}
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                    {{ item?.description }}
                  </div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (finalSubmitted || addNewCustomMaterialForm.controls['mainMaterial']?.touched) &&
                  (addNewCustomMaterialForm.controls['mainMaterial']?.invalid ||
                    addNewCustomMaterialForm.controls['mainMaterial'].value?.description ===
                      'Material')
                "
                class="input-error"
              >
                End-of-life treatment is required.
              </div>
            </div>
          </div>
        </div>

        <div class="input-error">
          <span>{{ material.error || material.processError }}</span>
        </div>
        <div class="portlet-body">
          <div class="panel-group">
            <div class="accordion">
              <div class="panel panel-default">
                <ngb-accordion [closeOthers]="true" activeIds="panel1" class="defaultClass">
                  <ngb-panel id="panel1" cardClass="open">
                    <ng-template ngbPanelTitle>
                      <div
                        class="panel-heading"
                        [ngClass]="{ 'disabled-popup': !checkEntireAccess }"
                      >
                        <label class="panel-title">
                          <a
                            class="accordion-toggle accordion-toggle-styled"
                            data-toggle="collapse"
                            aria-expanded="false"
                          >
                            <span class="accordion-text"
                              >Add materials required to produce 1 kg of custom material</span
                            >
                          </a>
                        </label>
                      </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div id="divaddmaterialList" class="grid-div">
                        <input
                          data-val="true"
                          data-val-number="The field CustomMaterialId must be a number."
                          data-val-required="The CustomMaterialId field is required."
                          id="CustomMaterialId"
                          name="CustomMaterialId"
                          type="hidden"
                          value="0"
                          placeholder="Search..."
                        />
                        <piqet-angular-portlet
                          [columnDefs]="materialColumnDef"
                          [frameworkComponents]="frameworkComponents"
                          [gridData]="customMaterialData.materialIngredients"
                          [hidePagination]="true"
                          [hideSearch]="true"
                          [headerBtn]="headerBtn"
                          [headerBtnName]="headerBtnName"
                          [gridName]="gridNameMaterial"
                          [hideSideBar]="isHideSideBar"
                          [isCheckOrgaizationReport]="true"
                          [disableButton]="(!!material.error && disableSubmit) || isRowEditable"
                          [error]="material.error"
                          [class]="'overflowCheck'"
                          [createAccess]="checkEntireAccess"
                          [inlineEdit]="true"
                          [isInlineGrid]="true"
                          (editDataEvent)="checkValidation(material.error)"
                        >
                        </piqet-angular-portlet>
                      </div>
                    </ng-template>
                  </ngb-panel>
                  <ngb-panel id="panel2">
                    <ng-template ngbPanelTitle>
                      <div
                        class="panel-heading"
                        [ngClass]="{ 'disabled-popup': !checkEntireAccess }"
                      >
                        <label class="panel-title">
                          <a
                            class="accordion-toggle accordion-toggle-styled accordion-text"
                            data-toggle="collapse"
                            data-parent="#accordion3"
                            aria-expanded="false"
                          >
                            Process for manufacture of custom material
                          </a>
                        </label>
                      </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div id="divmanufactureofmaterialList" class="grid-div">
                        <input
                          data-val="true"
                          data-val-number="The field CustomMaterialId must be a number."
                          data-val-required="The CustomMaterialId field is required."
                          id="CustomMaterialId"
                          name="CustomMaterialId"
                          type="hidden"
                          value="0"
                        />
                        <piqet-angular-portlet
                          [columnDefs]="processColumnDef"
                          [frameworkComponents]="frameworkComponents"
                          [gridData]="customMaterialData.materialProcessList"
                          [isCheckOrgaizationReport]="true"
                          [hidePagination]="true"
                          [hideSearch]="true"
                          [headerBtn]="headerBtn"
                          [headerBtnName]="headerBtnNameForProcess"
                          [disableButton]="
                            (!!material.processError && disableSubmit) || isRowEditable
                          "
                          [error]="material.processError || errorNotification"
                          [gridName]="gridName"
                          [hideSideBar]="isHideSideBar"
                          [createAccess]="checkEntireAccess"
                          [inlineEdit]="true"
                          [isInlineGrid]="true"
                          [class]="'overflowCheck'"
                          (editDataEvent)="checkValidationForProcess(material.processError)"
                        >
                        </piqet-angular-portlet>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>
            </div>
          </div>
        </div>

        <div class="row pb-2" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
          <div class="col-sm-12">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  class="chkOverview"
                  [checked]="useDefaultDataSource"
                  (change)="toggleDataSource($event)"
                />
              </div>
              <div>
                <span class="checkbox-style pl-2">Use default data source</span>
                <span
                  class="tooltip-icon"
                  placement="bottom"
                  tooltipClass="sku-tooltip"
                  ngbTooltip="When selected, the system uses default data source values. Unselect to enter your own custom Source, Time Period, Geography, and Process values."
                >
                  <a class="info-icon">
                    <span>
                      <img
                        src="./assets/icons/grey-question-icon.svg"
                        alt="Info"
                        width="14"
                        height="14"
                      />
                    </span>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="!useDefaultDataSource">
          <div class="row" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
            <div class="col-sm-6">
              <div class="form-group">
                <piqet-angular-common-input
                  formControlName="source"
                  [control]="addNewCustomMaterialForm.get('source')"
                  label="Source"
                  placeholder="Source"
                >
                </piqet-angular-common-input>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <piqet-angular-common-input
                  formControlName="timePeriod"
                  [control]="addNewCustomMaterialForm.get('timePeriod')"
                  label="Time period"
                  placeholder="Time period"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>

          <div class="row" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
            <div class="col-sm-12">
              <div class="form-group textarea">
                <div class="services-form desc">
                  <textarea
                    formControlName="geography"
                    cols="20"
                    id="geography"
                    name="geography"
                    rows="2"
                    placeholder="Geography"
                  ></textarea>
                  <label for="geography">Geography</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
            <div class="col-sm-12">
              <div class="form-group textarea">
                <div class="services-form desc">
                  <textarea
                    formControlName="process"
                    cols="20"
                    id="process"
                    name="process"
                    rows="2"
                    placeholder="Process"
                  ></textarea>
                  <label for="process">Process</label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </form>
      <div class="setButtonAndError">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button
            type="button"
            class="modelBtn purpleBtnHoverEffect"
            [disabled]="
              !!material.processError || (!!material.error && disableSubmit) || isRowEditable
            "
            (click)="
              onSave(customMaterialData.materialIngredients, customMaterialData.materialProcessList)
            "
            *ngIf="checkEntireAccess"
          >
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            finalSubmitted &&
            (addNewCustomMaterialForm.controls['materialName']?.invalid ||
              addNewCustomMaterialForm.controls['mainMaterial']?.invalid ||
              addNewCustomMaterialForm.controls['mainMaterial'].value?.description === 'Material')
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span style="color: #f00">To proceed please complete the following fields : </span>
              </div>
              <div
                class="topBottomCss"
                *ngIf="addNewCustomMaterialForm.controls['materialName']?.invalid"
              >
                <div
                  *ngIf="addNewCustomMaterialForm.controls['materialName'].hasError('whitespace')"
                >
                  Material
                </div>
              </div>
              <div class="topBottomCss" *ngIf="isHideDropDown">
                <div
                  *ngIf="
                    addNewCustomMaterialForm.controls['organizationName']?.invalid ||
                    addNewCustomMaterialForm.controls['organizationName'].value?.name ===
                      'Organization' ||
                    (finalSubmitted &&
                      !addNewCustomMaterialForm.controls['organizationName'].value?.name)
                  "
                >
                  Organization
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    addNewCustomMaterialForm.controls['mainMaterial']?.invalid ||
                    addNewCustomMaterialForm.controls['mainMaterial'].value?.description ===
                      'Material'
                  "
                >
                  End-of-life treatment
                </div>
              </div>
              <div class="topBottomCss">
                <span>{{ material.error || material.processError }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
